export const mocksEnabledKey = "mocksEnabled";
export const customerServiceMockStateKey = "customerServiceMockEnabled";
export const mockOutcomeKey = "mockOutcome";
export const documentServiceMockStateKey = "documentServiceMockEnabled";
export const slowModeKey = "slowMode";
